import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { StoreModel } from "models/StoreModel";
import { LoginUserActions } from "redux/actions/LoginUserActions";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import Translator from "app/components/common/Translator";
import { withRouter } from "app/components/common/WithRouter";

interface Props {
    confirmDeleteAccount: typeof LoginUserActions.confirmDeleteAccount;
    match: UrlParams;
}

interface UrlParams {
    params: {
        email?: string;
        token?: string;
    }
}

// the mail link only opens this page, deleting needs the click, so mail scanners opening the link delete nothing
class ConfirmDeleteAccountComp extends React.Component<Props> {
    render() {
        const { email, token } = this.props.match.params;
        return (
            <div className="c-page__content">
                <PageContentHeader text="Delete Account" />
                <div className="c-card">
                    <Translator text="This deletes your account and all data of your company for good. This can not be undone." />
                    <button className="c-button c-button--danger" onClick={() => this.props.confirmDeleteAccount(email!, token!)} >
                        <Translator text="Delete account permanently" />
                    </button>
                </div>
            </div>
        )
    }
}

function mapStateToProps(_state: StoreModel) {
    return {
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        confirmDeleteAccount: bindActionCreators(LoginUserActions.confirmDeleteAccount, dispatch),
    };
}
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfirmDeleteAccountComp));
